import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Input, Tag, Drawer, Icon, message } from "@ezviz/ezd";
import FetchData from "@ezviz/FetchData";
import { useHistory, useLocation } from "react-router-dom";
import _ from "lodash";

import "./index.less";
const { Search } = Input;

function truncateText(text, keyword, length = 10) {
  //  优化大小写问题
  let _keyword = JSON.parse(JSON.stringify(keyword)).toLowerCase();
  let _text = JSON.parse(JSON.stringify(text)).toLowerCase();

  const index = _text.indexOf(_keyword);
  if (index !== -1) {
    if (index <= length) {
      return text;
    } else {
      for (let i = index - length; i < index; i++) {
        if (["，", "。", "！", "?", ";", ","].includes(text[i])) {
          return text.slice(index);
        }
      }
      return text.slice(index - length);
    }
  }
  return text;
}

export const SearchBox = () => {
  const history = useHistory();

  const [searchWord, setSearchWord] = useState("");
  const [visible, setVisible] = useState(false);
  // 抽屉内 联想词是否展示
  const [isShowWord, setIsShowWord] = useState(false);

  const inputRef = useRef(null);

  const [searchList, setSearchList] = useState([]);
  const hotWords = useRef([]);

  const [docInfo, setDocInfo] = useState({
    word: "",
    data: [],
    total: 0,
  });

  const onSearch = (s, isKeyWords = false) => {
    // 点击X号 会莫名触发 search 事件
    if (s) {
      if (s.length > 200) {
        return message.info("搜索仅支持最大200个字符");
      }
      const sTrim = s.trim();
      if (sTrim.length == 0) {
        return message.info("请输入正确搜索词");
      }

      setSearchWord(sTrim);
      !visible && openDrawer();
      getDoc(sTrim);
    }
  };
  const onChange = (e) => {
    setSearchWord(e.target.value);
    e.target.value &&
      byKeyWordGetlist((res) => {
        setSearchList(res.data.list || []);
      }, e.target.value);
    if (!e.target.value) {
      setDocInfo({
        word: "",
        data: [],
        total: 0,
      });
    }
  };
  const openDrawer = () => {
    setVisible(true);
  };
  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const searchTxt = params.get("searchTxt");
    if (searchTxt) {
      let arr = searchTxt.split("%u").slice(1);
      let decodedStr = arr
        .map((x) => String.fromCharCode(parseInt(x, 16)))
        .join("");
      setVisible(true);
      setSearchWord(decodedStr || searchTxt);
      onSearch(decodedStr || searchTxt);
    }

    getHotlist((res) => {
      try {
        let arr = res.data.split(",") || [];
        hotWords.current = arr.map((item) => {
          let t = item.split(":");
          let obj = {};
          obj.hotWord = t[0];
          obj.docId = t[1];
          return obj;
        });
      } catch (error) {
        hotWords.current = [];
      }
    });
  }, []);

  const getHotlist = (callback) => {
    const fetchData = new FetchData(
      "/web/console/doc/center/doc/hot/word/list",

      {
        method: "GET",
      }
    );
    fetchData
      .then((res) => {
        if (res.meta.code == 200) {
          callback(res);
        } else {
          // message.info("查询失败")
        }
      })
      .catch((e) => {
        // message.destroy();
        // message.error("请求失败");
      });
  };

  const byKeyWordGetlist = _.debounce((callback, searchWord) => {
    const fetchData = new FetchData("/web/console/doc/center/keyword/list", {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: {
        pageSize: 36,
        keyword: searchWord,
      },
      method: "POST",
    });
    fetchData
      .then((res) => {
        if (res.meta.code == 200) {
          callback(res);
        } else {
          // message.info("查询失败")
        }
      })
      .catch((e) => {
        // message.destroy();
        // message.error("请求失败");
      });
  }, 500);

  const getDoc = (_searchWord = "") => {
    if (_searchWord) {
      getDocAPI((res) => {
        res.data.forEach((i) => {
          let str = i.content.replace(/<\/?[^>]+(>|$)/g, "");
          str = str.replace(/\r\n/g, "");
          str = str.replace(/\s+/g, "");
          if (_searchWord) {
            str = truncateText(str, _searchWord, 10);
            // 先转义 再匹配
            str = str.replace(
              new RegExp(
                _searchWord.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"),
                "gi"
              ),
              "<blue>$&</blue>"
            );
            i.title = i.title.replace(
              new RegExp(
                _searchWord.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"),
                "gi"
              ),
              "<blue>$&</blue>"
            );

            if (i.from.length > 0) {
              i.from.forEach((_i) => {
                _i.title = _i.title.replace(
                  new RegExp(
                    _searchWord.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"),
                    "gi"
                  ),
                  "<blue>$&</blue>"
                );
              });
            }
          }
          i.higt = str;
        });
        setDocInfo({
          word: _searchWord,
          data: res.data || [],
          total: res.data.length || 0,
        });
      }, _searchWord);
    } else {
      // message.error("请输入搜索词");
    }
  };

  const getDocAPI = (callback, searchWord) => {
    const fetchData = new FetchData(
      `/web/console/doc/center/keyword/doc/search/list`,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        method: "POST",
        body: {
          searchWord,
          limit: 50,
        },
      }
    );
    fetchData
      .then((res) => {
        if (res.meta.code == 200) {
          callback(res);
        } else {
          // message.info("查询失败")
        }
      })
      .catch((e) => {
        message.destroy();
        message.error("请求失败");
      });
  };

  // 组件库bug 先兼容掉
  useEffect(() => {
    let myElement = null;
    const clickINorOUT = (event) => {
      if (myElement) {
        // 用鼠标点击位置处理
        const { clientX: x, clientY: y } = event;
        const { left, top, right, bottom } = myElement.getBoundingClientRect();
        if (x >= left && x <= right && y >= top && y <= bottom) {
          console.log("点击了输入框内部");
        } else {
          setVisible(false);
        }
        // 出现问题原因： DOM.contains 执行在dom更新之后，input 的关闭按钮在 dom更新时会消失 导致判断触发元素是否在dom内部失败

        // let isClickedInside = myElement.contains(event.target);
        // if (isClickedInside) {
        //   console.log("You clicked inside the element");
        // } else {
        // setVisible(false);
        // }
      }
    };
    if (visible) {
      searchWord && onSearch(searchWord);
      myElement = document.querySelectorAll(".search-box")[0];
      setTimeout(() => {
        inputRef.current && inputRef.current.focus();
        document.addEventListener("click", clickINorOUT);
      }, 200);
    }
    return () => {
      myElement &&
        myElement.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      setDocInfo({
        word: "",
        data: [],
        total: 0,
      });
      document.removeEventListener("click", clickINorOUT);
    };
  }, [visible]);

  // onSearch={(e) => onSearch(e)}
  //       onPressEnter={(e) => onSearch(e.target.value)}
  //       value={searchWord}
  //       onChange={onChange}
  return (
    <div className="search-wrap">
      <Search
        placeholder={"输入并搜索"}
        allowClear
        style={{ width: 300 }}
        noaddon
        onFocus={() => {
          setVisible(true);
        }}
        onSearch={() => {
          setVisible(true);
        }}
      />
      <Drawer
        className={"search-box"}
        placement="right"
        visible={visible}
        mask={false}
        onClose={() => setVisible(false)}
        zIndex={9999}
      >
        <div className="search-title">
          <Input
            placeholder={"输入并搜索"}
            allowClear
            value={searchWord}
            onChange={onChange}
            onPressEnter={(e) => onSearch(e.target.value)}
            style={{ width: "100%" }}
            noaddon
            ref={inputRef}
            onBlur={(e) => {
              console.log("blur------");
              setTimeout(() => {
                setIsShowWord(false);
              }, 200);
            }}
            onFocus={(e) => {
              console.log("foucus ------");
              setIsShowWord(true);
            }}
            prefix={
              <Icon
                type="search"
                onClick={() => {
                  onSearch(searchWord);
                }}
              />
            }
          />
          <Icon type="close" onClick={() => setVisible(false)} />
        </div>
        {searchWord && isShowWord && searchList.length > 0 && (
          <div className="search-word">
            <div className="word-warp">
              {searchList.map((item) => (
                <Tag
                  onClick={() => {
                    setSearchWord(item.word);
                    getDoc(item.word);
                  }}
                >
                  {item.word}
                </Tag>
              ))}
            </div>
          </div>
        )}
        {docInfo.word && (
          <div className="search-tip">
            以为您搜索到“
            <span style={{ color: "#407AFF" }}>{docInfo.word}</span>
            ”相关结果，共{docInfo.total}条
          </div>
        )}
        {hotWords.current.length > 0 && (
          <div className="search-tag">
            {hotWords.current.map((item) => (
              <Tag
                key={item.docId}
                onClick={() => {
                  history.push("/help/" + item.docId);
                  window.scrollTo({
                    top: 0,
                    behavior: "instant",
                  });
                }}
              >
                {item.hotWord}
              </Tag>
            ))}
          </div>
        )}

        <div className="search-article">
          {docInfo.data &&
            docInfo.data.map((item) => (
              <div
                className="article-item"
                onClick={() => {
                  history.push("/help/" + item.documentId);
                  window.scrollTo({
                    top: 0,
                    behavior: "instant",
                  });
                }}
              >
                <div
                  className="title"
                  dangerouslySetInnerHTML={{ __html: item.title }}
                ></div>
                <div
                  className="article"
                  dangerouslySetInnerHTML={{ __html: item.higt }}
                ></div>
                {item.from.length > 0 && (
                  <div className="art-menu">
                    来自：
                    {item.from.map((i, _i) => (
                      <span
                        onClick={(e) => {
                          if (i.docId && i.docId.length != 32) {
                            e.stopPropagation();
                            history.push("/help/" + i.docId);
                            window.scrollTo({
                              top: 0,
                              behavior: "instant",
                            });
                          }
                        }}
                        className={[
                          i.docId && i.docId.length != 32 ? "_from" : "",
                        ].join(" ")}
                        dangerouslySetInnerHTML={{
                          __html:
                            i.title + (_i < item.from.length - 1 ? ">" : ""),
                        }}
                      ></span>
                    ))}
                  </div>
                )}
              </div>
            ))}
        </div>
      </Drawer>
    </div>
  );
};
